import { PropertyCustomerList } from "../../../../store/sites/Type";

export const getMovOutClearDateState = (allCustomers: PropertyCustomerList[], customerInfo: PropertyCustomerList) => {
    const laterCustomerInfo = allCustomers.find((item) => new Date(item.start) > new Date(customerInfo.start));
    if (laterCustomerInfo) {
        return false;
    }
    return true;
}